/**
 * Funções utilitárias para formatação de valores
 * Padrão brasileiro: 25.000,00
 */

/**
 * Formata valor monetário para o padrão brasileiro
 * @param {number|string} value - Valor a ser formatado
 * @returns {string} Valor formatado (ex: "25.000,00")
 */
export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === '') return 'R$ 0,00';

  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numValue)) return 'R$ 0,00';

  return numValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

/**
 * Formata número para o padrão brasileiro (sem símbolo de moeda)
 * @param {number|string} value - Valor a ser formatado
 * @param {number} decimals - Número de casas decimais (padrão: 2)
 * @returns {string} Valor formatado (ex: "25.000,00")
 */
export const formatNumber = (value, decimals = 2) => {
  if (value === null || value === undefined || value === '') return '0,00';

  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numValue)) return '0,00';

  return numValue.toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
};

/**
 * Formata percentual
 * @param {number|string} value - Valor a ser formatado
 * @param {number} decimals - Número de casas decimais (padrão: 1)
 * @returns {string} Valor formatado (ex: "15,5%")
 */
export const formatPercentage = (value, decimals = 1) => {
  if (value === null || value === undefined || value === '') return '0%';

  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numValue)) return '0%';

  return `${numValue.toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })}%`;
};

/**
 * Formata número inteiro (sem decimais)
 * @param {number|string} value - Valor a ser formatado
 * @returns {string} Valor formatado (ex: "25.000")
 */
export const formatInteger = (value) => {
  if (value === null || value === undefined || value === '') return '0';

  const numValue = typeof value === 'string' ? parseInt(value) : value;

  if (isNaN(numValue)) return '0';

  return numValue.toLocaleString('pt-BR');
};
